const NameMapDtvS = {
  CHOICE: "CHOICE™",
  ENTERTAINMENT: "ENTERTAINMENT",
  PREMIER: "PREMIER",
  ULTIMATE: "ULTIMATE",
  LO: "LO MÁXIMO™",
  ULTRA: "MAS ULTRA™",
  LATINO: "MÁS LATINO™",
  "ÓPTIMO MÁS": "ÓPTIMO MÁS™",
  "OPTIMO MAS": "ÓPTIMO MÁS™"
};

const NameMapDtvI = {
  ENTERTAINMENT: "ENTERTAINMENT",
  CHOICE: "CHOICE",
  PREMIER: "PREMIER",
  ULTIMATE: "ULTIMATE",
  "OPTIMO MAS": "OPTIMO MAS",
  "ÓPTIMO MÁS": "OPTIMO MAS",
  "ÓPTIMO MÁS™": "OPTIMO MAS"
}

/**
 * Because key is not provided in CMS, must map product name to offer price name for stability
 * @param content CI string
 * @param isSatellite
 * @param isNoLocals
 */
export const getProductKey = (content: string, isSatellite: boolean, isNoLocals: boolean) => {
  if (!isSatellite) {
    const key = Object.keys(NameMapDtvI).find(key => content.includes(key));
    return NameMapDtvI[key] || "";
  }
  const key = Object.keys(NameMapDtvS).find(key => content.includes(key));
  if (isNoLocals) {
    return `${NameMapDtvS[key]} - No Locals`;
  }
  return NameMapDtvS[key] || "";
};

